import SplitManager from './SplitManager';

const Split = new SplitManager();

export default Split;
